export const goToRequestNewEquipment = () => {
  window.open(process.env.REACT_APP_REDIRECT_URL + 'universalRequest/1/2/39');
};
